<div class="auth-wrapper">
  <div class="align-items-center grid h-full">
    <div class="col-6 h-full">
      <div class="gc-auth-leftPanel">
       <div class="gc-idnty-container">
        <div class="gc-logo">
            <a href=""><img src="../../assets/images/io-logo-green.svg" alt="io-logo.svg"></a>
          </div>
          <div class="">
            <p class="mt-5">{{logoText}}</p>
          </div>
        </div>
        <div class="gc-auth-slider">
          <!-- <app-multi-slider></app-multi-slider> -->
          <img src="../../assets/images/banner.svg" alt="banner.svg">
        </div>
        </div>
    </div>
    <div class="col-6 relative justify-content-center flex align-items-center h-full">
      <div class="gc-auth-form-container">
        <h1>Create new password</h1>
        <p>io filled in your temporary password. Please create your new password.</p>
        <form (ngSubmit)="completeNewPassword()" [formGroup]="completeNewPasswordForm">
          <div class="mt-1 mb-5">
            <p-password type="password"
                        formControlName="oldPassword"
                        [toggleMask]="true"
                        [feedback]="false"
                        placeholder="Old Password"
                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                        required
                        [ngClass]="{'error-border-password': completeNewPasswordForm.get('oldPassword').touched &&
                        !completeNewPasswordForm.get('oldPassword').value}"></p-password>
          </div>
          <div class="mt-1 mb-5">
            <p-password type="password"
                        formControlName="newPassword"
                        [toggleMask]="true"
                        [feedback]="false"
                        placeholder="New Password"
                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                        required
                        [ngClass]="{'error-border-password': (completeNewPasswordForm.get('newPassword').touched &&
                        !completeNewPasswordForm.get('newPassword').value) ||
                         ((completeNewPasswordForm.get('newPassword').touched && completeNewPasswordForm.get('confirmNewPassword').touched) &&
                         completeNewPasswordForm.get('newPassword').value !== completeNewPasswordForm.get('confirmNewPassword').value)}"></p-password>
            <div class="password-error-text p-l-7">
              <span class="password-req">
              {{ PASSWORD_STRENGTH_VALIDATION_MESSAGE }}
            </span>
            </div>
          </div>

          <div class="mt-1 mb-5">
            <p-password type="password"
                        formControlName="confirmNewPassword"
                        [toggleMask]="true"
                        [feedback]="false"
                        placeholder="Confirm Password"
                        pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                        required
                        [ngClass]="{'error-border-password': (completeNewPasswordForm.get('confirmNewPassword').touched &&
                        !completeNewPasswordForm.get('confirmNewPassword').value) ||
                         ((completeNewPasswordForm.get('newPassword').touched && completeNewPasswordForm.get('confirmNewPassword').touched) &&
                         completeNewPasswordForm.get('newPassword').value !== completeNewPasswordForm.get('confirmNewPassword').value)}"></p-password>
            <div class="password-error-text">
              <p class="alert alert-danger mt-3" *ngIf="completeNewPasswordForm.get('confirmNewPassword').dirty && completeNewPasswordForm.get('confirmNewPassword').value !== completeNewPasswordForm.get('newPassword').value">
                {{ PASSWORDS_MUST_MATCH }}
              </p>
            </div>
          </div>
          <button type="submit" class="reset-btn">Reset Password</button>

        </form>
      </div>

      <app-footer></app-footer>
    </div>

</div>
</div>

